<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="ch00_fm03_pre02"></a><a id="page_ii"></a>O<span class="smallcaps">THER</span> B<span class="smallcaps">OOKS BY</span> M<span class="smallcaps">ARK</span> M<span class="smallcaps">ILLER</span></p>
<p class="textcenter"><em>The Secret of Teams<br/>The Secret of Teams Field Guide</em></p>
<p class="textcenter1">With Ken Blanchard</p>
<p class="textcenter"><em>Great Leaders Grow</em><br/><em>The Secret</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_pre02.vue?58c26d20